// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__s9f7Q","fixedContent":"Alert_fixedContent__m9n2S"};